import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { SuccessToast } from '../../components/ToastComponent/SuccessToast';
import firstWorldCapitalize from '../../utils/capitlizedFirstLatter';
import Konsole from '../../utils/konsole/Konsole';
import ParseFloat from '../../utils/ParseFloat';
import DownloadReceipt from './DownloadReceipt';
import { GetSavedCard } from '../../api/getSavedCard';
import useLogoFevIcon from '../../hooks/useLogoFevIcon';
import useSelectedStore from '../../hooks/useSelectedStore';
import { CLEARCART } from '../../redux/features/CartData';
import { CLEARALLORDER } from '../../redux/features/AllOrder';
import { CLEARCHECKOUTADDRESS, resetScheduleDeivery } from '../../redux/features/CheckoutAddress';
function NewOrderSuccess() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { logo, fevicon } = useLogoFevIcon()
    const { platformFee } = useSelectedStore()
    const location = useLocation();
    const reduxData = useSelector((state: any) => state)
    const { store: { selectedStore }, allOrder: { orders }, checkoutAddress, addressData: { address } }: any = useSelector((state: any) => state);
    // Access the passed data from location.state
    const orderId = location.state?.orderId
    const data = location.state?.data;
    useEffect(() => {
        const link: HTMLLinkElement = document.querySelector("link[rel='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = fevicon;
        document.head.appendChild(link);
    }, [selectedStore, fevicon]);


    const { userData: { user: { first_name, last_name } } } = reduxData;
    Konsole.log('reduxData', reduxData, first_name)
    // const [isExploding, setIsExploding] = useState(false);
    const navigate = useNavigate();




    useEffect(() => {
        let order_placed = sessionStorage.getItem('is_order_placed')
        if (order_placed == 'true') {
            SuccessToast(t("MyOrders.order_success_msg"));
            // fetchedSaveOrder()
        }

        sessionStorage.removeItem('is_order_placed');
        if (!orderId) {
            handleNavigate('/menu')
        }

        return () => {
            sessionStorage.removeItem('is_order_placed');
        }
    }, [])

    // async function fetchedSaveOrder() {
    //     // fetch saved card
    //     let storeId = reduxData.store.selectedStore.store_id
    //     let res = await GetSavedCard(dispatch, storeId)

    // }




    // const firstworldCapitalize = (str: string) => {
    //     return str.charAt(0).toUpperCase() + str.slice(1)
    // }



    const handleNavigate = (url?: any) => {

        dispatch(CLEARCART());
        dispatch(CLEARALLORDER());
        dispatch(CLEARCHECKOUTADDRESS());
        dispatch(resetScheduleDeivery());
        sessionStorage.removeItem("items");
        window.location.replace(url);
        // window.location.reload();
    }


    return (
        <div className="min-h-screen flex items-center justify-center bg-white ">
            <ToastContainer style={{ zIndex: "999999999" }} hideProgressBar={true} />
            {orderId ? <div className="max-w-sm mx-auto bg-white p-6 rounded  text-center mt-8 order-success-shadow">
                {/* <div className="flex justify-center mb-4">
                <img src="/images/Layer_2.png" loading="eager" alt="Order Success" className="w-[9.6rem] h-[10.5rem] mb-2" />
                <SuccessSvgIcon />
            </div> */}

                <h2 className="text-xl font-semibold mb-4 ">{t("OrderSuccess.orderSuccessfull")}</h2>

                <div className="text-left text-sm space-y-2 mb-6 ">
                    <div className="flex justify-between gap-16">
                        <span>{t("OrderSuccess.order")}</span>
                        <div className="break-all">
                            <span>#{orderId}</span>
                        </div>

                    </div>
                    <div className="flex justify-between">
                        <span>{t("OrderSuccess.payment")}</span>
                        <span>{firstWorldCapitalize(data?.payment_option)}</span>
                    </div>
                    {/* <div className="flex justify-between">
                    <span>{t("CartDetails.totalItems")}</span>
                   <span>{`${data?.items?.length}  ${data?.items?.length == 1 ? "item" : "items"}`}</span>
                </div>
                <hr /> */}
                    {data?.sub_total ? <div className="flex justify-between">
                        <span>{t("CartDetails.subTotals")}</span>
                        {<span>{ParseFloat(data?.sub_total)}</span>}
                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {data?.discountAmount ? <div className="flex justify-between">
                        <span>{t("MyOrders.discount")}</span>
                        {<span>{ParseFloat(data?.discountAmount)}</span>}
                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {data?.service_charge ? <div className="flex justify-between">
                        <span>{t("Checkout.serviceFee")}</span>
                        {<span>{ParseFloat(data?.service_charge)}</span>}

                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {data?.delivery_charges ? <div className="flex justify-between">
                        <span>{t("Checkout.deliveryFee")}</span>
                        {<span>{ParseFloat(data?.delivery_charges)}</span>}

                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {data?.remaning_amount ? <div className="flex justify-between">
                        <span>{t("MyOrders.remainingAmount")}</span>
                        {<span>{ParseFloat(data?.remaning_amount)}</span>}

                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {data?.total_tax ? <div className="flex justify-between">
                        <span>{t("MyOrders.taxes")}</span>
                        {<span>{ParseFloat(data?.total_tax)}</span>}

                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    {platformFee > 0 &&
                        <div className="flex justify-between">
                            <span>{t("CartDetails.platformFee")}</span>
                            {<span>{ParseFloat(platformFee)}</span>}

                            {/* <span>$00.00</span> */}
                        </div>
                    }
                    {platformFee > 0 &&
                        <div className="flex justify-between">
                            <span>{t("CartDetails.platformFee")}</span>
                            {<span>{ParseFloat(platformFee)}</span>}

                            {/* <span>$00.00</span> */}
                        </div>
                    }
                    {data?.round_off != 0 && (
                        <div className="flex justify-between ubermoveTextMedium textSm">
                            <p>{t("CartDetails.round_total")}</p>
                            <p>{ParseFloat(data?.round_off || 0)}</p>
                        </div>
                    )}
                    <hr />
                    {data?.total_price ? <div className="flex justify-between font-bold text-base">
                        <span>{t("CartDetails.total")}</span>
                        {<span>{ParseFloat(data?.total_price)}</span>}

                        {/* <span>$00.00</span> */}
                    </div> : ""}
                    <div className="flex gap-2 ">
                        <button
                            className="w-1/2 border border-gray-400 text-gray-800 py-2 rounded"
                            onClick={() => handleNavigate('/my-order')}
                        >
                            {t("OrderSuccess.viewOrder")}
                        </button>
                        <button
                            className="w-1/2 border border-gray-400 text-gray-800 py-2 rounded"
                            onClick={() => handleNavigate('/')}
                        >
                            {t("OrderSuccess.newOrder")}
                        </button>
                    </div>

                    {/* @@ download receipt btn */}
                    <DownloadReceipt t={t} data={data} orderId={orderId} />
                </div>



            </div>
                : ""}

        </div>
    )
}



export default NewOrderSuccess;
